import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";

export function NotificationsBell() {
  const [data, setData] = useState({ items: [], unread: 0 });
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const load = () => api.get("/notifications").then(r => setData(r.data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 45000); return () => clearInterval(t); }, []);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h);
  }, []);
  const toggle = async () => {
    setOpen(o => !o);
    if (!open && data.unread) { await api.post("/notifications/read").catch(() => {}); setData(d => ({ ...d, unread: 0, items: d.items.map(n => ({ ...n, read: true })) })); }
  };
  return (
    <div ref={ref} className="relative">
      <button data-testid="header-notifications" onClick={toggle} className="p-2 rounded-full hover:bg-zinc-100 transition-colors relative">
        <Bell size={18} />
        {data.unread > 0 && <span data-testid="notif-unread" className="absolute -top-0.5 -right-0.5 bg-[#c8102e] text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">{data.unread}</span>}
      </button>
      {open && (
        <div data-testid="notif-panel" className="absolute right-0 mt-1 w-80 max-w-[90vw] bg-white rounded-2xl border border-zinc-200 shadow-xl z-50 max-h-96 overflow-y-auto">
          {data.items.length === 0 && <p className="text-xs text-zinc-500 text-center py-6">Sem notificações.</p>}
          {data.items.map(n => (
            <Link key={n.id} to={n.link || "/notificacoes"} onClick={() => setOpen(false)} data-testid={`notif-${n.id}`} className={`block px-3 py-2.5 border-b border-zinc-100 hover:bg-zinc-50 ${n.read ? "" : "bg-[#fff8d6]"}`}>
              <div className="text-xs font-semibold">{n.title}</div><div className="text-[11px] text-zinc-600">{n.body}</div>
              <div className="text-[10px] text-zinc-400 mt-0.5">{new Date(n.created_at).toLocaleString("pt-PT")}</div>
            </Link>
          ))}
          <Link to="/notificacoes" onClick={() => setOpen(false)} data-testid="notif-see-all" className="block text-center text-xs font-semibold py-2.5 hover:bg-zinc-50">Ver todas e preferências</Link>
        </div>
      )}
    </div>
  );
}
